export default __webpack_public_path__ + "static/media/UnionPay.7427dd46.svg";